<template>
  <div class="kc-zy-show">
    <div class="chineseMedicineBox">
      <span class="chineseMedicine" v-for="(item, i) in prescripItem.prescripDrugsList" :key="i">
        {{
          item.drugName +
          ' ' +
          item.useAuantity +
          (item.measureUnitValue || item.measureUnit) +
          ' ' +
          [item.drugDesc ? '（' + getKeyValueText('prescrip_desc', item.drugDesc) + '）' : '']
        }}
      </span>
      <!-- 宁城中心医院中草药打码 -->
      <div class="mask" v-if="['28770'].includes(hospitalID)">
        <img class="image" src="@funcPuzzle/mini_patient/groundGlass.png" />
      </div>
    </div>
    <!-- 宁城中心医院 -->
    <div v-if="['28770'].includes(hospitalID)" class="chineseMedicineBottom">
      <div class="margin-bto-20">
        <span>剂数：{{ prescripItem.doesNumber + ' ' }}</span>
      </div>
      <div class="margin-bto-20">
        <span>
          用法：{{ getKeyValueText('chinese_drug_usage', prescripItem.chineseDrugUsage) }}
        </span>
      </div>
      <div class="margin-bto-20">
        <span>
          频率：{{
            prescripItem.herbFrequence
              ? getKeyValueText('chinese_drug_frequence_his', prescripItem.herbFrequence || '')
              : ''
          }}
        </span>
      </div>
      <div class="margin-bto-20">
        <span>
          {{ prescripItem.herbPerDoseTimes ? '每剂' + prescripItem.herbPerDoseTimes + '次' : '' }}
        </span>
      </div>

      <div class="margin-bto-20" v-if="prescripItem.attention">
        <span>嘱托：{{ prescripItem.attention || '- -' }}</span>
      </div>
    </div>
    <!-- 其他医院 -->
    <div v-else class="chineseMedicineBottom">
      <div class="diamond">
        {{ getKeyValueText('process_method', prescripItem.processMethod) }}
      </div>
      <div class="margin-bto-20">
        <span>剂数：{{ prescripItem.doesNumber + ' ' }}</span>
        <span style="padding-left: 10px"> 次数：{{ prescripItem.times || '' }} </span>
      </div>
      <div class="margin-bto-20">
        <span>
          用法：{{ getKeyValueText('chinese_drug_usage', prescripItem.chineseDrugUsage) }}
        </span>
      </div>
      <div v-if="prescripItem.prescripDesc" class="margin-bto-20">
        <span>处方说明：{{ prescripItem.prescripDesc }}</span>
      </div>
      <div class="margin-bto-20" v-if="prescripItem.attention">
        <span>嘱托：{{ prescripItem.attention || '- -' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'

export default {
  props: {
    prescripItem: {
      type: Object,
      default: ''
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    }
  },
  methods: {
    getKeyValueText
  }
}
</script>

<style lang="scss" scoped>
.chineseMedicineBox {
  position: relative;
  width: 580px;
  margin-left: 32px;
  margin-top: 32px;

  .chineseMedicine {
    font-size: 30px;
    color: #222;
    padding-right: 20px;
  }

  .mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .image {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}

.chineseMedicineBottom {
  position: relative;
  box-sizing: border-box;
  padding-left: 32px;
  padding-top: 20px;
  margin: 32px auto;
  width: 622px;
  min-height: 188px;
  background-color: #fff;
  color: #888;
  font-size: 24px;
  border-radius: 8px;

  .diamond {
    position: absolute;
    top: 14px;
    right: 32px;
    padding: 10px 12px;
    color: #222;
    font-size: 24px;
    background-color: #f2f2f2;
    border-radius: 4px;
  }
}
</style>
